import { render, staticRenderFns } from "./work-breadcrumb.vue?vue&type=template&id=1937c1ef&scoped=true"
import script from "./work-breadcrumb.vue?vue&type=script&lang=ts"
export * from "./work-breadcrumb.vue?vue&type=script&lang=ts"
import style0 from "./work-breadcrumb.vue?vue&type=style&index=0&id=1937c1ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1937c1ef",
  null
  
)

export default component.exports